import { render, staticRenderFns } from "./QueuePriority.vue?vue&type=template&id=b4f1a80e&"
import script from "./QueuePriority.vue?vue&type=script&lang=js&"
export * from "./QueuePriority.vue?vue&type=script&lang=js&"
import style0 from "./QueuePriority.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports